import {ADD_ORDER} from '../constants';

export default (state = null, action) => {
  switch (action.type) {
    case ADD_ORDER:
      return action.payload.data || null;
    default:
      return state;
  }
};
